import React from 'react';

export const OtherSkills = () => {
  return (
    <div className="skills_content">
      <h3 className="skill_title">Other Skills</h3>

      <div className="skills_group grid">
        {/* git */}
        <div className="skills_data">
          <i className="bx bxl-git bx-burst"></i>
          <h3 className="skills_name">git</h3>
        </div>

        {/* OOP */}
        <div className="skills_data">
          <i className="bx bx-code-curly bx-burst"></i>
          <h3 className="skills_name">OOP</h3>
        </div>

        {/* Data Structure */}
        <div className="skills_data">
          <i className="bx bx-data bx-burst"></i>
          <h3 className="skills_name">Data Structure</h3>
        </div>

        {/* VS Code */}
        <div className="skills_data">
          <i className="bx bxl-visual-studio bx-burst"></i>
          <h3 className="skills_name">VS Code</h3>
        </div>

        {/* API */}
        <div className="skills_data">
          <i className="bx bx-network-chart bx-burst"></i>
          <h3 className="skills_name">API</h3>
        </div>

        {/* Postman */}
        <div className="skills_data">
        <i className="bx bx-wrench bx-burst"></i>
          <h3 className="skills_name">Postman</h3>
        </div>

        {/* Adobe Premiere */}
        <div className="skills_data">
          <i className="uil uil-video bx-burst"></i>
          <h3 className="skills_name">Adobe Premiere</h3>
        </div>

        {/* Google Tools */}
        <div className="skills_data">
          <i className="bx bxl-google bx-burst"></i>
          <h3 className="skills_name">Google Tools</h3>
        </div>
      </div>
    </div>
  );
};
